//
//
//
//
//
//
//
//
//
//
//
//

import ButtonRouter from './ButtonRouter.vue';
export default {
  name: 'Banner',
  components: {
    ButtonRouter
  },
  props: {
    title: {
      type: String,
      required: true,
      default: '',
    },
    cta: {
      type: Object,
      required: true,
      default: function () {
      return {text:'', url: ''}
      }
    },
    image: {
      type: String,
      required: true,
    },
    backgroundColor: {
      type: String,
      default: '',
    },
    headerColor: {
      type: String,
      default: '#0f1e3c',
    },
    imageFullWidth: {
      type: Boolean,
      default: false,
    },
    contentPosition: {
      type: String,
      default: 'center',
      validator: (value) => ['center', 'left', 'right'].includes(value),
    },
    componentName: {
      type: String,
      required: false,
      default: 'Banner',
    },
  },
  computed: {
    bannerBackgroundStyle() {
      const style = { backgroundImage: `url(${this.image})`};

      if (this.backgroundColor) {
        style.backgroundColor = this.backgroundColor;
      }

      if (this.imageFullWidth) {
        style.backgroundPosition = 'center';
        style.backgroundSize = 'cover';
      }

      return style;
    },
    getButtonName() {
      return `${this.componentName}_Banner_Button_To_${this.cta.url}`
    }
 },
};
